import React, { FC } from 'react';
import { SortableTable } from '../../molecules';
import { Action, Label, TableRow } from '../../atoms';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';

interface LandscapeAboutContactPersonsOrganismProps {
  contactPersons: LandscapeContactPersonResponseDto[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
}

const LandscapeAboutContactPersonsOrganism: FC<
  LandscapeAboutContactPersonsOrganismProps
> = ({ contactPersons, handleEdit, handleDelete }) => {
  return (
    <SortableTable
      data={contactPersons}
      columns={[
        { label: 'Contact Person', key: 'name' },
        { label: 'Role', key: 'role' },
        { label: 'Email Address', key: 'emailAddress' },
      ]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.name} />
          <Label content={row.role} />
          <Label content={row.emailAddress} />
          <Action type="edit" onClick={() => handleEdit(row.id)} size="sm" />
          <Action
            type="delete"
            itemName={row.name}
            onClick={() => handleDelete(row.id)}
            size="sm"
          />
        </TableRow>
      )}
    />
  );
};

export default LandscapeAboutContactPersonsOrganism;
